import React from 'react'
import './Footer.css'
import footer_logo from '../Assets/logo_big.png'
import { Link } from 'react-router-dom'
import { 
  FaFacebookF, 
  FaTiktok, 
  FaInstagram,
  FaWhatsapp 
} from 'react-icons/fa'
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi'
import { MdOutlinePayment } from 'react-icons/md'
import { BsShieldCheck } from 'react-icons/bs'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      {/* Newsletter Section */}
     

      <div className="footer-main">
        {/* Brand Section */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={footer_logo} alt="NepliShop" loading="lazy" decoding="async" fetchpriority="low" width="80" height="80" />
            <div className="brand-text">
          
              <span className="shop-text">NEPLISHOP</span>
            </div>
          </div>
          <p className="brand-tagline">
            Your premier destination for trendy fashion and quality products
          </p>
          <div className="contact-info">
            <div className="contact-item">
              <FiPhone className="contact-icon" />
              <span>+977 9741761409</span>
            </div>
            <div className="contact-item">
              <FiMail className="contact-icon" />
              <span>neplishop.com@gmail.com</span>
            </div>
            <div className="contact-item">
              <FiMapPin className="contact-icon" />
              <span>Kathmandu, Nepal</span>
            </div>
          </div>
        </div>

        {/* Quick Links Grid */}
        <div className="footer-links-grid">
          {/* Shop Categories */}
          <div className="links-column">
            <h4>Shopping</h4>
            <ul>
              <li><Link to="/">New Arrivals</Link></li>
              <li><Link to="/men">Men's Collection</Link></li>
              <li><Link to="/women">Women's Collection</Link></li>
              <li><Link to="/kids">Kids & Teens</Link></li>
              <li><Link to="/shoes">Footwear</Link></li>
             
            </ul>
          </div>

          {/* Information */}
          <div className="links-column">
            <h4>Our Collections</h4>
            <ul>
              <li><Link to="/shoes">Shoes</Link></li>
              <li><Link to="/mens">Pants</Link></li>
              <li><Link to="/womens">Shirts</Link></li>
              <li><Link to="/kids">Vest</Link></li>
              <li><Link to="/mens">T-Shirts</Link></li>

            </ul>
          </div>

          {/* Customer Service */}
          <div className="links-column">
            <h4>Know More</h4>
            <ul>
              <li><Link to='/contact-us' >Contact Us</Link></li>
              <li><Link to='/team' >Our Team</Link></li>
              <li><Link to='/about-neplishop' >About Neplishop</Link></li>
              

            </ul>
          </div>

          {/* Legal & Policies */}
          <div className="links-column">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms" >Terms of Service</Link></li>
              <li><Link to='/cookies' >Cookie Policy</Link></li>
             

            </ul>
          </div>
        </div>
      </div>

      {/* Trust & Payment Section */}
      <div className="footer-trust">
        <div className="trust-badges">
          <div className="trust-item">
            <BsShieldCheck className="trust-icon" />
            <span>100% Secure Payments</span>
          </div>
          <div className="trust-item">
            <MdOutlinePayment className="trust-icon" />
            <span>SSL Encrypted</span>
          </div>
          <div className="trust-item">
            <span className="trust-text">30-Day Returns</span>
          </div>
          <div className="trust-item">
            <span className="trust-text">Free Delivery Services</span>
          </div>
        </div>

       
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="social-links">
          <span> <h3>Follow Us On :-</h3></span>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/14S7jNXiTMt/" className="social-icon facebook">
              <FaFacebookF />
            </a>
            
            <a href="https://www.instagram.com/neplishop?igsh=MWZ4Mzg0MTMwcTQxeQ==" className="social-icon instagram">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@neplishop?_r=1&_t=ZS-93B4595FjpB" className="social-icon tiktok">
              <FaTiktok />
            </a>
      
            <a href="https://wa.me/9779741761409   " className="social-icon whatsapp">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <div className="footer-copyright">
          <p>Copyright © {currentYear} NepliShop. All rights reserved.</p>
        
        </div>

        
      </div>

  
    
    </footer>
  )
}

export default Footer
